"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importStar(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'Toggle';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const CLASSNAME_LIGHT = (0, utils_1.getClassName)(COMPONENT_NAME, 'light');
class ForwardRefToggle extends react_1.Component {
    constructor() {
        super(...arguments);
        this._ref = node => {
            var _a, _b;
            this._node = node;
            (_b = (_a = this.props).innerRef) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
    }
    focus() {
        this._node.focus();
    }
    render() {
        const _a = this.props, { 
        // remove - remapped and local props
        className, 'data-tid': dataTid, id, innerRef } = _a, // eslint-disable-line @typescript-eslint/no-unused-vars
        // pass all other props to Carbon
        otherCarbonProps = tslib_1.__rest(_a, ["className", 'data-tid', "id", "innerRef"]);
        const { light } = this.props;
        const mappedProps = {
            'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : DEFAULT_TID,
            id: id !== null && id !== void 0 ? id : (0, utils_1.getUniqueId)(DISPLAY_NAME),
            ref: this._ref,
        };
        if (className || light) {
            mappedProps.className = `${className !== null && className !== void 0 ? className : ''} ${light ? CLASSNAME_LIGHT : ''}`;
        }
        return react_1.default.createElement(carbon_components_react_1.Toggle, Object.assign({}, otherCarbonProps, mappedProps));
    }
}
ForwardRefToggle.propTypes = {
    // light variant to workaround https://jsw.ibm.com/browse/BAUICOMMON-218
    light: prop_types_1.default.bool,
};
const Toggle = react_1.default.forwardRef((props, ref) => {
    const otherProps = ref ? { innerRef: ref } : {};
    return react_1.default.createElement(ForwardRefToggle, Object.assign({}, props, otherProps));
});
Toggle.displayName = DISPLAY_NAME;
exports.default = Toggle;
